// extracted by mini-css-extract-plugin
module.exports = {"icon_wrapper":"FileInput_icon_wrapper__23Vz0","disabledAction":"FileInput_disabledAction__mnMxj"};